const DEBUG_MODE_I18N = 'i18nDebug';

function checkUrlParam(param: string) {
	const urlSearchParams = window.location.search;
	const urlParams = new URLSearchParams(urlSearchParams);
	return urlParams.has(param);
}

export function isDebugI18nEnabled(): boolean {
	return checkUrlParam(DEBUG_MODE_I18N);
}
